import messages from './messages';

const getTranslations = ({ intl }) => ({
    backButtonText: intl.formatMessage(messages.back),
    publishButtonText: intl.formatMessage(messages.publish),
    productSelectorPlaceholderText: intl.formatMessage(messages.selectProduct),
    productSelectorHeadingText: intl.formatMessage(messages.productSelectorHeading),
    saveCourseButtonText: intl.formatMessage(messages.save)
});

export default getTranslations;



// WEBPACK FOOTER //
// ./app/components/course-creator/translations.js